// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WorkOrders_headerActions__aGkQD {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.WorkOrders_badge__8KEOY {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.WorkOrders_priorityUrgent__RFNMp {
  background: #fef2f2;
  color: #ef4444;
  border: 1px solid #fecaca;
}

.WorkOrders_priorityHigh__GpuLr {
  background: #fff7ed;
  color: #ea580c;
  border: 1px solid #fed7aa;
}

.WorkOrders_priorityNormal__4Zja7 {
  background: #eff6ff;
  color: #2563eb;
  border: 1px solid #bfdbfe;
}

.WorkOrders_priorityLow__EuRFN {
  background: #f3f4f6;
  color: #6b7280;
  border: 1px solid #e5e7eb;
}

.WorkOrders_statusDraft__ziSGj {
  background: #f3f4f6;
  color: #4b5563;
}

.WorkOrders_statusPlanned__rYHwS {
  background: #eff6ff;
  color: #2563eb;
}

.WorkOrders_statusInProgress__l5B\\+N {
  background: #fef3c7;
  color: #d97706;
}

.WorkOrders_statusPaused__IOzeL {
  background: #fee2e2;
  color: #b91c1c;
}

.WorkOrders_statusCompleted__J6sI3 {
  background: #ecfdf5;
  color: #059669;
}

.WorkOrders_statusCancelled__4lkLi {
  background: #f3f4f6;
  color: #9ca3af;
}

.WorkOrders_progressWrap__epXxI {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 120px;
}

.WorkOrders_progressTrack__xuhzz {
  flex: 1 1;
  height: 8px;
  border-radius: 4px;
  background: var(--m-border-color, #e5e7eb);
  overflow: hidden;
}

.WorkOrders_progressFill__bD7TP {
  height: 100%;
  border-radius: 4px;
  transition: width 0.4s ease;
}

.WorkOrders_progressPct__aE4qt {
  font-size: 11px;
  font-weight: 600;
  color: var(--m-text-subtle, #6b7280);
  min-width: 32px;
  text-align: right;
}

.WorkOrders_expandedCell__fCvPk {
  padding: 16px 24px !important;
  background: #f8fafc !important;
  max-width: 0 !important;
  width: 100% !important;
  box-sizing: border-box !important;
}

.WorkOrders_pipelineWrapper__n1cRZ {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.WorkOrders_pipelineContainer__Cpwnb {
  display: flex;
  align-items: stretch;
  gap: 16px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: auto;
  box-sizing: border-box;
  padding: 16px 4px 24px;
  margin-top: 10px;
}
.WorkOrders_pipelineContainer__Cpwnb::-webkit-scrollbar {
  height: 8px;
}
.WorkOrders_pipelineContainer__Cpwnb::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 4px;
}

.WorkOrders_pipelineStep__tiRtN {
  display: flex;
  align-items: stretch;
  flex-shrink: 0;
}

.WorkOrders_stageCard__WxJHM {
  width: 300px;
  min-width: 300px;
  max-width: 300px;
  box-sizing: border-box;
  background: #ffffff;
  border: 2px solid var(--m-border-color, #e5e7eb);
  border-radius: 12px;
  padding: 14px 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 220px;
  height: 100%;
  flex-shrink: 0;
}
.WorkOrders_stageCard__WxJHM:hover {
  border-color: var(--m-primary, #00b4f3);
  box-shadow: 0 4px 12px rgba(0, 180, 243, 0.15);
}
.WorkOrders_stageCard__WxJHM.WorkOrders_fulfilledFromStock__yNJi3 {
  background: #f8fafc;
  border-color: #cbd5e1;
}
.WorkOrders_stageCard__WxJHM.WorkOrders_activeStage__lzab9 {
  border-color: #f59e0b;
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.2);
}

.WorkOrders_stageHeader__WrPF6 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.WorkOrders_stageNumberBadge__socW4 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--m-primary, #00b4f3);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.WorkOrders_stagePartName__Cp-UU {
  font-size: 14px;
  font-weight: 600;
  color: var(--m-text, #1a2236);
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.WorkOrders_stagePartCode__22Kp4 {
  font-size: 11px;
  color: var(--m-text-subtle, #6b7280);
  margin-bottom: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.WorkOrders_stageMetrics__dP5Wn {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding: 8px 10px;
  background: var(--m-surface-subtle, #f9fafb);
  border-radius: 6px;
  margin-bottom: 12px;
  font-size: 12px;
  box-sizing: border-box;
  min-height: 52px;
}
.WorkOrders_stageMetrics__dP5Wn strong {
  display: block;
  font-size: 13px;
  color: var(--m-text, #111827);
}

.WorkOrders_stageStockBox__8\\+E-S {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border-radius: 6px;
  margin-bottom: 12px;
  font-size: 12px;
  box-sizing: border-box;
  min-height: 38px;
}
.WorkOrders_stageStockBox__8\\+E-S.WorkOrders_sufficient__vFEDB {
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  color: #065f46;
}
.WorkOrders_stageStockBox__8\\+E-S.WorkOrders_insufficient__sff-S {
  background: #fff8f8;
  border: 1px solid #fecaca;
  color: #991b1b;
}

.WorkOrders_stockToggleContainer__66IT7 {
  min-height: 26px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}

.WorkOrders_stockToggleLabel__5uITZ {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  -webkit-user-select: none;
          user-select: none;
  margin: 0;
}

.WorkOrders_stockToggleLabelDisabled__qtOyv {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  color: var(--m-text-subtle, #94a3b8);
  -webkit-user-select: none;
          user-select: none;
  cursor: not-allowed;
  margin: 0;
}

.WorkOrders_stageAssignmentSection__l2Dtc {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 160px;
  border-top: 1px dashed var(--m-border-color, #e5e7eb);
  padding-top: 10px;
  margin-top: auto;
  box-sizing: border-box;
}
.WorkOrders_stageAssignmentSection__l2Dtc .m-select {
  margin-bottom: 0;
}

.WorkOrders_stockFulfilledCard__tNjYm {
  flex: 1 1;
  min-height: 145px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #f0fdf4;
  border: 1px dashed #86efac;
  border-radius: 8px;
  padding: 14px 12px;
  box-sizing: border-box;
}

.WorkOrders_stockFulfilledIcon__zxKDr {
  color: #10b981;
  margin-bottom: 8px;
}

.WorkOrders_stockFulfilledTitle__cEFeM {
  font-size: 13px;
  font-weight: 700;
  color: #15803d;
  margin-bottom: 4px;
}

.WorkOrders_stockFulfilledDesc__zUDwD {
  font-size: 11px;
  line-height: 1.4;
  color: #166534;
}

.WorkOrders_stageMachineBox__Gqu-t {
  margin-bottom: 8px;
}

.WorkOrders_stageOperatorBox__df430 {
  margin-top: 0;
}

.WorkOrders_noMachineWarning__sp74F {
  color: #dc2626;
  font-size: 11px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  background: #fef2f2;
  border-radius: 6px;
  border: 1px solid #fecaca;
  line-height: 1.3;
}

.WorkOrders_autoMachineBadge__F0AdG {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 6px;
  color: #166534;
  font-size: 12px;
  font-weight: 600;
}

.WorkOrders_pipelineArrow__wf-zv {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  color: #9ca3af;
  font-size: 20px;
  align-self: center;
}

.WorkOrders_operatorContainer__z5iR1 {
  max-width: 800px;
  margin: 0 auto;
  padding: 12px;
}

.WorkOrders_operatorMachineSelect__mFSTI {
  margin-bottom: 16px;
}

.WorkOrders_operatorMainCard__OzqOW {
  background: #ffffff;
  border: 1px solid var(--m-border-color, #e5e7eb);
  border-radius: 14px;
  padding: 20px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  margin-bottom: 20px;
}

.WorkOrders_operatorActionBar__-Btt\\+ {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 20px;
}
@media (max-width: 576px) {
  .WorkOrders_operatorActionBar__-Btt\\+ {
    grid-template-columns: 1fr;
  }
}

.WorkOrders_bigTouchButton__jCRs1 {
  min-height: 48px;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 8px;
}

.WorkOrders_instructionBox__AEYp2 {
  background: var(--m-surface-subtle, #f8fafc);
  border: 1px solid var(--m-border, #eaecf0);
  border-left: 4px solid var(--m-primary, #00b4f3);
  padding: 12px 16px;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1.6;
  color: var(--m-text, #1a2236);
  margin: 16px 0;
  white-space: pre-wrap;
}

.WorkOrders_formCard__2RH-B {
  margin-bottom: 24px;
}

.WorkOrders_formCardContent__qN7cM {
  padding: 24px 28px !important;
  height: auto !important;
}
@media (max-width: 768px) {
  .WorkOrders_formCardContent__qN7cM {
    padding: 16px 14px !important;
  }
}

.WorkOrders_cardSectionHeader__z92Wg {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--m-border, #e2e8f0);
}

.WorkOrders_cardSectionTitle__tgUuX {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 15px;
  font-weight: 700;
  color: var(--m-text, #0f172a);
}

.WorkOrders_formGrid__yQ5wJ {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
}
.WorkOrders_formGrid__yQ5wJ:last-child {
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/views/pages/WorkOrders/WorkOrders.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AADF;;AAOA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAJF;;AAOA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAJF;;AAOA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAJF;;AAOA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAJF;;AAOA;EACE,mBAAA;EACA,cAAA;AAJF;;AAOA;EACE,mBAAA;EACA,cAAA;AAJF;;AAOA;EACE,mBAAA;EACA,cAAA;AAJF;;AAOA;EACE,mBAAA;EACA,cAAA;AAJF;;AAOA;EACE,mBAAA;EACA,cAAA;AAJF;;AAOA;EACE,mBAAA;EACA,cAAA;AAJF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AALF;;AAQA;EACE,SAAA;EACA,WAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;AALF;;AAQA;EACE,YAAA;EACA,kBAAA;EACA,2BAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,eAAA;EACA,iBAAA;AALF;;AASA;EACE,6BAAA;EACA,8BAAA;EACA,uBAAA;EACA,sBAAA;EACA,iCAAA;AANF;;AASA;EACE,aAAA;EACA,qCAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;AANF;;AASA;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,gBAAA;AANF;AAQE;EACE,WAAA;AANJ;AAQE;EACE,mBAAA;EACA,kBAAA;AANJ;;AAUA;EACE,aAAA;EACA,oBAAA;EACA,cAAA;AAPF;;AAUA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gDAAA;EACA,mBAAA;EACA,kBAAA;EACA,yCAAA;EACA,wDAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;AAPF;AASE;EACE,uCAAA;EACA,8CAAA;AAPJ;AAUE;EACE,mBAAA;EACA,qBAAA;AARJ;AAWE;EACE,qBAAA;EACA,6CAAA;AATJ;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAVF;;AAaA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAVF;;AAaA;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAVF;;AAaA;EACE,eAAA;EACA,oCAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAVF;;AAaA;EACE,aAAA;EACA,8BAAA;EACA,QAAA;EACA,iBAAA;EACA,4CAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;AAVF;AAYE;EACE,cAAA;EACA,eAAA;EACA,6BAAA;AAVJ;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;AAXF;AAaE;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AAXJ;AAaE;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AAXJ;;AAeA;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAZF;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,SAAA;AAZF;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,SAAA;AAZF;;AAeA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,iBAAA;EACA,qDAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AAZF;AAcE;EACE,gBAAA;AAZJ;;AAgBA;EACE,SAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AAbF;;AAgBA;EACE,cAAA;EACA,kBAAA;AAbF;;AAgBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAbF;;AAgBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAbF;;AAgBA;EACE,kBAAA;AAbF;;AAgBA;EACE,aAAA;AAbF;;AAgBA;EACE,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAbF;;AAiBA;EACE,gBAAA;EACA,cAAA;EACA,aAAA;AAdF;;AAiBA;EACE,mBAAA;AAdF;;AAiBA;EACE,mBAAA;EACA,gDAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;AAdF;AAgBE;EANF;IAOI,0BAAA;EAbF;AACF;;AAgBA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;AAbF;;AAgBA;EACE,4CAAA;EACA,0CAAA;EACA,gDAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,cAAA;EACA,qBAAA;AAbF;;AAiBA;EACE,mBAAA;AAdF;;AAiBA;EACE,6BAAA;EACA,uBAAA;AAdF;AAgBE;EAJF;IAKI,6BAAA;EAbF;AACF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;EACA,iDAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;AAbF;;AAgBA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AAbF;AAeE;EACE,gBAAA;AAbJ","sourcesContent":["// ─── Work Orders Module SCSS ───────────────────────────────────────────────────\n\n.headerActions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n\n\n// ─── Priority & Status Badges ─────────────────────────────────────────────────\n.badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 10px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.priorityUrgent {\n  background: #fef2f2;\n  color: #ef4444;\n  border: 1px solid #fecaca;\n}\n\n.priorityHigh {\n  background: #fff7ed;\n  color: #ea580c;\n  border: 1px solid #fed7aa;\n}\n\n.priorityNormal {\n  background: #eff6ff;\n  color: #2563eb;\n  border: 1px solid #bfdbfe;\n}\n\n.priorityLow {\n  background: #f3f4f6;\n  color: #6b7280;\n  border: 1px solid #e5e7eb;\n}\n\n.statusDraft {\n  background: #f3f4f6;\n  color: #4b5563;\n}\n\n.statusPlanned {\n  background: #eff6ff;\n  color: #2563eb;\n}\n\n.statusInProgress {\n  background: #fef3c7;\n  color: #d97706;\n}\n\n.statusPaused {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.statusCompleted {\n  background: #ecfdf5;\n  color: #059669;\n}\n\n.statusCancelled {\n  background: #f3f4f6;\n  color: #9ca3af;\n}\n\n// ─── Progress Bar ─────────────────────────────────────────────────────────────\n.progressWrap {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 120px;\n}\n\n.progressTrack {\n  flex: 1;\n  height: 8px;\n  border-radius: 4px;\n  background: var(--m-border-color, #e5e7eb);\n  overflow: hidden;\n}\n\n.progressFill {\n  height: 100%;\n  border-radius: 4px;\n  transition: width 0.4s ease;\n}\n\n.progressPct {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--m-text-subtle, #6b7280);\n  min-width: 32px;\n  text-align: right;\n}\n\n// ─── Visual Pipeline Flow (Hat Şeması) ─────────────────────────────────────────\n.expandedCell {\n  padding: 16px 24px !important;\n  background: #f8fafc !important;\n  max-width: 0 !important;\n  width: 100% !important;\n  box-sizing: border-box !important;\n}\n\n.pipelineWrapper {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.pipelineContainer {\n  display: flex;\n  align-items: stretch;\n  gap: 16px;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  overflow-x: auto;\n  box-sizing: border-box;\n  padding: 16px 4px 24px;\n  margin-top: 10px;\n\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: #d1d5db;\n    border-radius: 4px;\n  }\n}\n\n.pipelineStep {\n  display: flex;\n  align-items: stretch;\n  flex-shrink: 0;\n}\n\n.stageCard {\n  width: 300px;\n  min-width: 300px;\n  max-width: 300px;\n  box-sizing: border-box;\n  background: #ffffff;\n  border: 2px solid var(--m-border-color, #e5e7eb);\n  border-radius: 12px;\n  padding: 14px 16px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-height: 220px;\n  height: 100%;\n  flex-shrink: 0;\n\n  &:hover {\n    border-color: var(--m-primary, #00b4f3);\n    box-shadow: 0 4px 12px rgba(0, 180, 243, 0.15);\n  }\n\n  &.fulfilledFromStock {\n    background: #f8fafc;\n    border-color: #cbd5e1;\n  }\n\n  &.activeStage {\n    border-color: #f59e0b;\n    box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.2);\n  }\n}\n\n.stageHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.stageNumberBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: var(--m-primary, #00b4f3);\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.stagePartName {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--m-text, #1a2236);\n  margin-bottom: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.stagePartCode {\n  font-size: 11px;\n  color: var(--m-text-subtle, #6b7280);\n  margin-bottom: 10px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.stageMetrics {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  padding: 8px 10px;\n  background: var(--m-surface-subtle, #f9fafb);\n  border-radius: 6px;\n  margin-bottom: 12px;\n  font-size: 12px;\n  box-sizing: border-box;\n  min-height: 52px;\n\n  strong {\n    display: block;\n    font-size: 13px;\n    color: var(--m-text, #111827);\n  }\n}\n\n.stageStockBox {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 10px;\n  border-radius: 6px;\n  margin-bottom: 12px;\n  font-size: 12px;\n  box-sizing: border-box;\n  min-height: 38px;\n\n  &.sufficient {\n    background: #ecfdf5;\n    border: 1px solid #a7f3d0;\n    color: #065f46;\n  }\n  &.insufficient {\n    background: #fff8f8;\n    border: 1px solid #fecaca;\n    color: #991b1b;\n  }\n}\n\n.stockToggleContainer {\n  min-height: 26px;\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n}\n\n.stockToggleLabel {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  user-select: none;\n  margin: 0;\n}\n\n.stockToggleLabelDisabled {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--m-text-subtle, #94a3b8);\n  user-select: none;\n  cursor: not-allowed;\n  margin: 0;\n}\n\n.stageAssignmentSection {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  min-height: 160px;\n  border-top: 1px dashed var(--m-border-color, #e5e7eb);\n  padding-top: 10px;\n  margin-top: auto;\n  box-sizing: border-box;\n\n  :global(.m-select) {\n    margin-bottom: 0;\n  }\n}\n\n.stockFulfilledCard {\n  flex: 1;\n  min-height: 145px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  background: #f0fdf4;\n  border: 1px dashed #86efac;\n  border-radius: 8px;\n  padding: 14px 12px;\n  box-sizing: border-box;\n}\n\n.stockFulfilledIcon {\n  color: #10b981;\n  margin-bottom: 8px;\n}\n\n.stockFulfilledTitle {\n  font-size: 13px;\n  font-weight: 700;\n  color: #15803d;\n  margin-bottom: 4px;\n}\n\n.stockFulfilledDesc {\n  font-size: 11px;\n  line-height: 1.4;\n  color: #166534;\n}\n\n.stageMachineBox {\n  margin-bottom: 8px;\n}\n\n.stageOperatorBox {\n  margin-top: 0;\n}\n\n.noMachineWarning {\n  color: #dc2626;\n  font-size: 11px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 10px;\n  background: #fef2f2;\n  border-radius: 6px;\n  border: 1px solid #fecaca;\n  line-height: 1.3;\n}\n\n.autoMachineBadge {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  background: #f0fdf4;\n  border: 1px solid #bbf7d0;\n  border-radius: 6px;\n  color: #166534;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.pipelineArrow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 12px;\n  color: #9ca3af;\n  font-size: 20px;\n  align-self: center;\n}\n\n// ─── Operator Mobile Interface ────────────────────────────────────────────────\n.operatorContainer {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 12px;\n}\n\n.operatorMachineSelect {\n  margin-bottom: 16px;\n}\n\n.operatorMainCard {\n  background: #ffffff;\n  border: 1px solid var(--m-border-color, #e5e7eb);\n  border-radius: 14px;\n  padding: 20px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);\n  margin-bottom: 20px;\n}\n\n.operatorActionBar {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-top: 20px;\n\n  @media (max-width: 576px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.bigTouchButton {\n  min-height: 48px;\n  font-size: 14px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border-radius: 8px;\n}\n\n.instructionBox {\n  background: var(--m-surface-subtle, #f8fafc);\n  border: 1px solid var(--m-border, #eaecf0);\n  border-left: 4px solid var(--m-primary, #00b4f3);\n  padding: 12px 16px;\n  border-radius: 6px;\n  font-size: 13px;\n  line-height: 1.6;\n  color: var(--m-text, #1a2236);\n  margin: 16px 0;\n  white-space: pre-wrap;\n}\n\n// ─── Work Order Form Page Styles ──────────────────────────────────────────\n.formCard {\n  margin-bottom: 24px;\n}\n\n.formCardContent {\n  padding: 24px 28px !important;\n  height: auto !important;\n\n  @media (max-width: 768px) {\n    padding: 16px 14px !important;\n  }\n}\n\n.cardSectionHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid var(--m-border, #e2e8f0);\n}\n\n.cardSectionTitle {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--m-text, #0f172a);\n}\n\n.formGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 20px;\n  margin-bottom: 20px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerActions": `WorkOrders_headerActions__aGkQD`,
	"badge": `WorkOrders_badge__8KEOY`,
	"priorityUrgent": `WorkOrders_priorityUrgent__RFNMp`,
	"priorityHigh": `WorkOrders_priorityHigh__GpuLr`,
	"priorityNormal": `WorkOrders_priorityNormal__4Zja7`,
	"priorityLow": `WorkOrders_priorityLow__EuRFN`,
	"statusDraft": `WorkOrders_statusDraft__ziSGj`,
	"statusPlanned": `WorkOrders_statusPlanned__rYHwS`,
	"statusInProgress": `WorkOrders_statusInProgress__l5B+N`,
	"statusPaused": `WorkOrders_statusPaused__IOzeL`,
	"statusCompleted": `WorkOrders_statusCompleted__J6sI3`,
	"statusCancelled": `WorkOrders_statusCancelled__4lkLi`,
	"progressWrap": `WorkOrders_progressWrap__epXxI`,
	"progressTrack": `WorkOrders_progressTrack__xuhzz`,
	"progressFill": `WorkOrders_progressFill__bD7TP`,
	"progressPct": `WorkOrders_progressPct__aE4qt`,
	"expandedCell": `WorkOrders_expandedCell__fCvPk`,
	"pipelineWrapper": `WorkOrders_pipelineWrapper__n1cRZ`,
	"pipelineContainer": `WorkOrders_pipelineContainer__Cpwnb`,
	"pipelineStep": `WorkOrders_pipelineStep__tiRtN`,
	"stageCard": `WorkOrders_stageCard__WxJHM`,
	"fulfilledFromStock": `WorkOrders_fulfilledFromStock__yNJi3`,
	"activeStage": `WorkOrders_activeStage__lzab9`,
	"stageHeader": `WorkOrders_stageHeader__WrPF6`,
	"stageNumberBadge": `WorkOrders_stageNumberBadge__socW4`,
	"stagePartName": `WorkOrders_stagePartName__Cp-UU`,
	"stagePartCode": `WorkOrders_stagePartCode__22Kp4`,
	"stageMetrics": `WorkOrders_stageMetrics__dP5Wn`,
	"stageStockBox": `WorkOrders_stageStockBox__8+E-S`,
	"sufficient": `WorkOrders_sufficient__vFEDB`,
	"insufficient": `WorkOrders_insufficient__sff-S`,
	"stockToggleContainer": `WorkOrders_stockToggleContainer__66IT7`,
	"stockToggleLabel": `WorkOrders_stockToggleLabel__5uITZ`,
	"stockToggleLabelDisabled": `WorkOrders_stockToggleLabelDisabled__qtOyv`,
	"stageAssignmentSection": `WorkOrders_stageAssignmentSection__l2Dtc`,
	"stockFulfilledCard": `WorkOrders_stockFulfilledCard__tNjYm`,
	"stockFulfilledIcon": `WorkOrders_stockFulfilledIcon__zxKDr`,
	"stockFulfilledTitle": `WorkOrders_stockFulfilledTitle__cEFeM`,
	"stockFulfilledDesc": `WorkOrders_stockFulfilledDesc__zUDwD`,
	"stageMachineBox": `WorkOrders_stageMachineBox__Gqu-t`,
	"stageOperatorBox": `WorkOrders_stageOperatorBox__df430`,
	"noMachineWarning": `WorkOrders_noMachineWarning__sp74F`,
	"autoMachineBadge": `WorkOrders_autoMachineBadge__F0AdG`,
	"pipelineArrow": `WorkOrders_pipelineArrow__wf-zv`,
	"operatorContainer": `WorkOrders_operatorContainer__z5iR1`,
	"operatorMachineSelect": `WorkOrders_operatorMachineSelect__mFSTI`,
	"operatorMainCard": `WorkOrders_operatorMainCard__OzqOW`,
	"operatorActionBar": `WorkOrders_operatorActionBar__-Btt+`,
	"bigTouchButton": `WorkOrders_bigTouchButton__jCRs1`,
	"instructionBox": `WorkOrders_instructionBox__AEYp2`,
	"formCard": `WorkOrders_formCard__2RH-B`,
	"formCardContent": `WorkOrders_formCardContent__qN7cM`,
	"cardSectionHeader": `WorkOrders_cardSectionHeader__z92Wg`,
	"cardSectionTitle": `WorkOrders_cardSectionTitle__tgUuX`,
	"formGrid": `WorkOrders_formGrid__yQ5wJ`
};
export default ___CSS_LOADER_EXPORT___;
